'use client';

import { useDecisions } from '../../hooks';
import { BrandContentLegacy } from './BrandContent.legacy';
import { BrandContentV2 } from './BrandContent.v2';

type BrandContentProps = {
    initializeWebcollage: () => void;
};

export function BrandContentScript({ initializeWebcollage }: BrandContentProps) {
    const isOneTrust = useDecisions('onetrust');

    const ScriptComponent = isOneTrust ? BrandContentV2 : BrandContentLegacy;

    return <ScriptComponent initializeWebcollage={initializeWebcollage} />;
}
